import { BaseApiRequest } from '@api/BaseApi';
import { objectToQuery } from '@api/helpers';

export const getPortDetails = (signal, portId) => {
  return BaseApiRequest(signal, `/Port/PortDetails/${portId}`, 'geo');
};
export const getPortsDetails = (signal, body) => {
  return BaseApiRequest(signal, `/Ports/PortDetails`, 'geo', 'POST', body);
};

export const getGlobalPortCongestion = (data, signal) => {
  const query = objectToQuery(data);
  return BaseApiRequest(signal, `/GlobalPortCongestion?${query}`);
};

export const getPortTrafficData = (portIds, signal, startDate, endDate, imos = []) => {
  // Ensure portIds is always an array
  const portIdArray = Array.isArray(portIds) ? portIds : [portIds];

  const body = {
    portIds: portIdArray,
    start: startDate.toISOString(),
    end: endDate.toISOString(),
    imos: imos
  };

  return BaseApiRequest(signal, `/Vessel/ReportedDestinationTimeline`, 'ais', 'POST', body);
};
